import React from "react";
import "../styles/FullScreenSpinner.css";

const FullscreenSpinner = () => {
  return (
    <div className="fullscreen-spinner">
      <div className="loading-wrapper">
        <img
          src="/assets/logo.png"
          alt="Loading"
          className="loading-logo"
        />
        <div className="loading-text">Loading...</div>
      </div>
    </div>
  );
};

export default FullscreenSpinner;
